// Audio imports
import welcomeMessage01 from "../assets/welcomeAudios/Welcome1.mp3";
import welcomeMessage02 from "../assets/welcomeAudios/Welcome2.mp3";
import welcomeMessage03 from "../assets/welcomeAudios/Welcome3.mp3";
import welcomeMessage04 from "../assets/welcomeAudios/Welcome4.mp3";
import welcomeMessage05 from "../assets/welcomeAudios/Welcome5.mp3";
import welcomeMessage06 from "../assets/welcomeAudios/Welcome6.mp3";
import welcomeMessage07 from "../assets/welcomeAudios/Welcome7.mp3";
import welcomeMessage08 from "../assets/welcomeAudios/Welcome8.mp3";
import welcomeMessage09 from "../assets/welcomeAudios/Welcome9.mp3";
import welcomeMessage10 from "../assets/welcomeAudios/Welcome10.mp3";
import welcomeMessage11 from "../assets/welcomeAudios/Welcome11.mp3";
import welcomeMessage12 from "../assets/welcomeAudios/Welcome12.mp3";
import welcomeMessage13 from "../assets/welcomeAudios/Welcome13.mp3";
import welcomeMessage14 from "../assets/welcomeAudios/Welcome14.mp3";
import welcomeMessage15 from "../assets/welcomeAudios/Welcome15.mp3";
import welcomeMessage16 from "../assets/welcomeAudios/Welcome16.mp3";
import welcomeMessage17 from "../assets/welcomeAudios/Welcome17.mp3";
import welcomeMessage18 from "../assets/welcomeAudios/Welcome18.mp3";
import welcomeMessage19 from "../assets/welcomeAudios/Welcome19.mp3";
import welcomeMessage20 from "../assets/welcomeAudios/Welcome20.mp3";
import welcomeMessage21 from "../assets/welcomeAudios/Welcome21.mp3";
import welcomeMessage22 from "../assets/welcomeAudios/Welcome22.mp3";
import welcomeMessage23 from "../assets/welcomeAudios/Welcome23.mp3";
import welcomeMessage24 from "../assets/welcomeAudios/Welcome24.mp3";
import welcomeMessage25 from "../assets/welcomeAudios/Welcome25.mp3";
import welcomeMessage26 from "../assets/welcomeAudios/Welcome26.mp3";
import welcomeMessage27 from "../assets/welcomeAudios/Welcome27.mp3";
import welcomeMessage28 from "../assets/welcomeAudios/Welcome28.mp3";
import welcomeMessage29 from "../assets/welcomeAudios/Welcome29.mp3";
import welcomeMessage30 from "../assets/welcomeAudios/Welcome30.mp3";
import welcomeMessage31 from "../assets/welcomeAudios/Welcome31.mp3";
import welcomeMessage32 from "../assets/welcomeAudios/Welcome32.mp3";
import welcomeMessage33 from "../assets/welcomeAudios/Welcome33.mp3";
import welcomeMessage34 from "../assets/welcomeAudios/Welcome34.mp3";
import welcomeMessage35 from "../assets/welcomeAudios/Welcome35.mp3";
import welcomeMessage36 from "../assets/welcomeAudios/Welcome36.mp3";
import welcomeMessage37 from "../assets/welcomeAudios/Welcome37.mp3";
import welcomeMessage38 from "../assets/welcomeAudios/Welcome38.mp3";
import welcomeMessage39 from "../assets/welcomeAudios/Welcome39.mp3";
import welcomeMessage40 from "../assets/welcomeAudios/Welcome40.mp3";
import welcomeMessage41 from "../assets/welcomeAudios/Welcome41.mp3";
import welcomeMessage42 from "../assets/welcomeAudios/Welcome42.mp3";
import welcomeMessage43 from "../assets/welcomeAudios/Welcome43.mp3";
import welcomeMessage44 from "../assets/welcomeAudios/Welcome44.mp3";
import welcomeMessage45 from "../assets/welcomeAudios/Welcome45.mp3";


// Lip sync JSON imports (Azure OVR visemes, generated by: cd backend && npx ts-node scripts/generate-welcome-lipsync.ts)
// These will be undefined until the JSON files are generated
import welcomeMessage01LipSync from "../assets/welcomeAudios/Welcome1.json";
import welcomeMessage02LipSync from "../assets/welcomeAudios/Welcome2.json";
import welcomeMessage03LipSync from "../assets/welcomeAudios/Welcome3.json";
import welcomeMessage04LipSync from "../assets/welcomeAudios/Welcome4.json";
import welcomeMessage05LipSync from "../assets/welcomeAudios/Welcome5.json";
import welcomeMessage06LipSync from "../assets/welcomeAudios/Welcome6.json";
import welcomeMessage07LipSync from "../assets/welcomeAudios/Welcome7.json";
import welcomeMessage08LipSync from "../assets/welcomeAudios/Welcome8.json";
import welcomeMessage09LipSync from "../assets/welcomeAudios/Welcome9.json";
import welcomeMessage10LipSync from "../assets/welcomeAudios/Welcome10.json";
import welcomeMessage11LipSync from "../assets/welcomeAudios/Welcome11.json";
import welcomeMessage12LipSync from "../assets/welcomeAudios/Welcome12.json";
import welcomeMessage13LipSync from "../assets/welcomeAudios/Welcome13.json";
import welcomeMessage14LipSync from "../assets/welcomeAudios/Welcome14.json";
import welcomeMessage15LipSync from "../assets/welcomeAudios/Welcome15.json";
import welcomeMessage16LipSync from "../assets/welcomeAudios/Welcome16.json";
import welcomeMessage17LipSync from "../assets/welcomeAudios/Welcome17.json";
import welcomeMessage18LipSync from "../assets/welcomeAudios/Welcome18.json";
import welcomeMessage19LipSync from "../assets/welcomeAudios/Welcome19.json";
import welcomeMessage20LipSync from "../assets/welcomeAudios/Welcome20.json";
import welcomeMessage21LipSync from "../assets/welcomeAudios/Welcome21.json";
import welcomeMessage22LipSync from "../assets/welcomeAudios/Welcome22.json";
import welcomeMessage23LipSync from "../assets/welcomeAudios/Welcome23.json";
import welcomeMessage24LipSync from "../assets/welcomeAudios/Welcome24.json";
import welcomeMessage25LipSync from "../assets/welcomeAudios/Welcome25.json";
import welcomeMessage26LipSync from "../assets/welcomeAudios/Welcome26.json";
import welcomeMessage27LipSync from "../assets/welcomeAudios/Welcome27.json";
import welcomeMessage28LipSync from "../assets/welcomeAudios/Welcome28.json";
import welcomeMessage29LipSync from "../assets/welcomeAudios/Welcome29.json";
import welcomeMessage30LipSync from "../assets/welcomeAudios/Welcome30.json";
import welcomeMessage31LipSync from "../assets/welcomeAudios/Welcome31.json";
import welcomeMessage32LipSync from "../assets/welcomeAudios/Welcome32.json";
import welcomeMessage33LipSync from "../assets/welcomeAudios/Welcome33.json";
import welcomeMessage34LipSync from "../assets/welcomeAudios/Welcome34.json";
import welcomeMessage35LipSync from "../assets/welcomeAudios/Welcome35.json";
import welcomeMessage36LipSync from "../assets/welcomeAudios/Welcome36.json";
import welcomeMessage37LipSync from "../assets/welcomeAudios/Welcome37.json";
import welcomeMessage38LipSync from "../assets/welcomeAudios/Welcome38.json";
import welcomeMessage39LipSync from "../assets/welcomeAudios/Welcome39.json";
import welcomeMessage40LipSync from "../assets/welcomeAudios/Welcome40.json";
import welcomeMessage41LipSync from "../assets/welcomeAudios/Welcome41.json";
import welcomeMessage42LipSync from "../assets/welcomeAudios/Welcome42.json";
import welcomeMessage43LipSync from "../assets/welcomeAudios/Welcome43.json";
import welcomeMessage44LipSync from "../assets/welcomeAudios/Welcome44.json";
import welcomeMessage45LipSync from "../assets/welcomeAudios/Welcome45.json";

import { LipSyncData } from "../api/generateFunnyAudio";

export interface WelcomeAudioWithLipSync {
  audio: string;
  lipSync: LipSyncData | null;
}

/**
 * Array of welcome audios with their corresponding lip sync data.
 * Lip sync data is pre-generated using Azure Speech (OVR viseme format).
 * If lip sync is null, the character will still animate (Idle/Talking) but without mouth movements.
 */
export const welcomeAudiosWithLipSync: WelcomeAudioWithLipSync[] = [
  { audio: welcomeMessage01, lipSync: welcomeMessage01LipSync as LipSyncData },
  { audio: welcomeMessage02, lipSync: welcomeMessage02LipSync as LipSyncData },
  { audio: welcomeMessage03, lipSync: welcomeMessage03LipSync as LipSyncData },
  { audio: welcomeMessage04, lipSync: welcomeMessage04LipSync as LipSyncData },
  { audio: welcomeMessage05, lipSync: welcomeMessage05LipSync as LipSyncData },
  { audio: welcomeMessage06, lipSync: welcomeMessage06LipSync as LipSyncData },
  { audio: welcomeMessage07, lipSync: welcomeMessage07LipSync as LipSyncData },
  { audio: welcomeMessage08, lipSync: welcomeMessage08LipSync as LipSyncData },
  { audio: welcomeMessage09, lipSync: welcomeMessage09LipSync as LipSyncData },
  { audio: welcomeMessage10, lipSync: welcomeMessage10LipSync as LipSyncData },
  { audio: welcomeMessage11, lipSync: welcomeMessage11LipSync as LipSyncData },
  { audio: welcomeMessage12, lipSync: welcomeMessage12LipSync as LipSyncData },
  { audio: welcomeMessage13, lipSync: welcomeMessage13LipSync as LipSyncData },
  { audio: welcomeMessage14, lipSync: welcomeMessage14LipSync as LipSyncData },
  { audio: welcomeMessage15, lipSync: welcomeMessage15LipSync as LipSyncData },
  { audio: welcomeMessage16, lipSync: welcomeMessage16LipSync as LipSyncData },
  { audio: welcomeMessage17, lipSync: welcomeMessage17LipSync as LipSyncData },
  { audio: welcomeMessage18, lipSync: welcomeMessage18LipSync as LipSyncData },
  { audio: welcomeMessage19, lipSync: welcomeMessage19LipSync as LipSyncData },
  { audio: welcomeMessage20, lipSync: welcomeMessage20LipSync as LipSyncData },
  { audio: welcomeMessage21, lipSync: welcomeMessage21LipSync as LipSyncData },
  { audio: welcomeMessage22, lipSync: welcomeMessage22LipSync as LipSyncData },
  { audio: welcomeMessage23, lipSync: welcomeMessage23LipSync as LipSyncData },
  { audio: welcomeMessage24, lipSync: welcomeMessage24LipSync as LipSyncData },
  { audio: welcomeMessage25, lipSync: welcomeMessage25LipSync as LipSyncData },
  { audio: welcomeMessage26, lipSync: welcomeMessage26LipSync as LipSyncData },
  { audio: welcomeMessage27, lipSync: welcomeMessage27LipSync as LipSyncData },
  { audio: welcomeMessage28, lipSync: welcomeMessage28LipSync as LipSyncData },
  { audio: welcomeMessage29, lipSync: welcomeMessage29LipSync as LipSyncData },
  { audio: welcomeMessage30, lipSync: welcomeMessage30LipSync as LipSyncData },
  { audio: welcomeMessage31, lipSync: welcomeMessage31LipSync as LipSyncData },
  { audio: welcomeMessage32, lipSync: welcomeMessage32LipSync as LipSyncData },
  { audio: welcomeMessage33, lipSync: welcomeMessage33LipSync as LipSyncData },
  { audio: welcomeMessage34, lipSync: welcomeMessage34LipSync as LipSyncData },
  { audio: welcomeMessage35, lipSync: welcomeMessage35LipSync as LipSyncData },
  { audio: welcomeMessage36, lipSync: welcomeMessage36LipSync as LipSyncData },
  { audio: welcomeMessage37, lipSync: welcomeMessage37LipSync as LipSyncData },
  { audio: welcomeMessage38, lipSync: welcomeMessage38LipSync as LipSyncData },
  { audio: welcomeMessage39, lipSync: welcomeMessage39LipSync as LipSyncData },
  { audio: welcomeMessage40, lipSync: welcomeMessage40LipSync as LipSyncData },
  { audio: welcomeMessage41, lipSync: welcomeMessage41LipSync as LipSyncData },
  { audio: welcomeMessage42, lipSync: welcomeMessage42LipSync as LipSyncData },
  { audio: welcomeMessage43, lipSync: welcomeMessage43LipSync as LipSyncData },
  { audio: welcomeMessage44, lipSync: welcomeMessage44LipSync as LipSyncData },
  { audio: welcomeMessage45, lipSync: welcomeMessage45LipSync as LipSyncData },
];

/**
 * Legacy export for backward compatibility.
 * Use welcomeAudiosWithLipSync for new code.
 */
export const welcomeAudios = welcomeAudiosWithLipSync.map((item) => item.audio);

/**
 * Get a random welcome audio with its lip sync data
 */
export const getRandomWelcomeAudio = (): WelcomeAudioWithLipSync => {
  const randomIndex = Math.floor(Math.random() * welcomeAudiosWithLipSync.length);
  return welcomeAudiosWithLipSync[randomIndex];
};
